import React from 'react';

import { Typography } from '@mui/material';

import { PageLayout } from '@klokhuis/core/PageLayout';
import { ListingSearchBar } from '@klokhuis/modules/Properties/components/ListingSearchBar';
import styles from './Search.module.css';
import { useMediaIsDesktop } from '@klokhuis/utilities/Media/useMediaIsDesktop';

const Search = () => {
  const [isLocationRequired, setIsLocationRequired] = React.useState(false);
  const isDesktop = useMediaIsDesktop();
  const resetLocationError = React.useCallback(() => {
    setIsLocationRequired(false);
  }, []);

  return (
    <PageLayout.SectionContainer className={styles.root}>
      <div className={styles.headerContainer}>
        <Typography
          variant={isDesktop ? 'h2' : 'h4'}
          className={styles.mainTitle}
        >
          Find Your Perfect Property
        </Typography>
        {isDesktop && (
          <Typography variant="subtitle2" className={styles.subTitle}>
            Discover premium farm lands, villas, and commercial spaces across
            prime locations
          </Typography>
        )}
      </div>
      <div className={styles.sectionContainer}>
        <ListingSearchBar
          variant="pill"
          className={styles.listingSearchBar}
          isLocationRequired={isLocationRequired}
          onLocationInputChange={resetLocationError}
        />
      </div>
      {/* <div className={styles.filterContainer}>
        <PropertyTypeFilter />
      </div> */}
    </PageLayout.SectionContainer>
  );
};

export default Search;
